import _ from 'lodash';
import createStore, { reduxStore } from '../../shared/store';
import { buildReducerEntries, buildInitialState } from './reducers';
import buildRoutesMap from './routes';
import buildRootSaga from './sagas';

export default async (props = {}) => {
  const { company } = props;

  let companyName = null;
  if (company) {
    companyName = company.subdomain;
  }

  const initialState = await buildInitialState(props);

  const reducers = await buildReducerEntries({
    companyName,
  });
  const routesMap = await buildRoutesMap({
    companyName,
    user: _.get(initialState, 'user'),
  });
  const rootSaga = await buildRootSaga({
    companyName,
  });

  return createStore({
    initialState,
    reducers,
    routesMap,
    rootSaga,
  });
};

export const updateReducersAndRoutesMap = async ({ companyName }) => {
  const newRoutesMap = await buildRoutesMap({ companyName });
  const newReducers = await buildReducerEntries({ companyName });
  reduxStore().updateReducersAndRoutesMap({ newRoutesMap, newReducers });
};
